define('Components/NewsWidget/js/views/NewsColWidgetInstanceView',['jquery','WidgetInstanceView','app','template!Components/NewsWidget/templates/default','template!Components/NewsWidget/templates/2-cols'],
    function($,WidgetInstanceView,app,defaultTemplate,colsTemplate){
    return WidgetInstanceView.extend({
        name:'NewsWidgetInstanceView',
        activeSlide: 0,
        events: {
            'click .prev':'prevSlide',
            'click .next':'nextSlide'
        },
        getTemplate:function(){
            switch(this.model.getTemplate()){
                case 'default': default: return defaultTemplate; break;
                case '2-cols': return colsTemplate; break;
            }
        },
        afterRender: function(){
            var self = this;
            self.listenTo(app,'change:scrollTop',self.onScroll);
        },
        onScroll: function(){
            var sel = this.$('.left-centered>div');
            if(sel.length > 0 && !sel.hasClass('active')) {
                if (app.get('scrollTop') > sel.offset().top - app.get('winH') + sel.height()) {
                    sel.addClass('active');
                }
            }
        },
        nextSlide: function(){
            var self = this;
            if(self.activeSlide < (this.model.getNbNews() - 1)) {
                self.activeSlide++;
                self.$('.visuals ul, .content ul').css('left', -(100 * self.activeSlide) + '%');
            }
        },
        prevSlide: function(){
            var self = this;
            if(self.activeSlide > 0) {
                self.activeSlide--;
                self.$('.visuals ul, .content ul').css('left', -(100 * self.activeSlide) + '%');
            }
        }

    })
});
